import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { updateAuthenticationToken } from '@/features/authentication-update-token/store/thunks/update-authentication-token';
import { UpdateAuthProduct } from '@/features/authentication-update-token/types';
import { getAuthCookies } from '@/features/cookies/auth-cookies';
import { useSessionContext } from '@/features/game/hooks/use-session-context';
import { requestIdSelector } from '@/features/game/store/game-data';
import {
  PokerProviderNamesToFgp,
  ProviderNameToFgp,
} from '@/features/game/types';
import { gameContextSelector } from '@/features/game-context/store/game-context';
import { Product } from '@/features/game-context/types';
import { useAppDispatch } from '@/store/hooks';

export const useUpdateAuthToken = () => {
  const dispatch = useAppDispatch();
  const sessionContext = useSessionContext();
  const { userId, provider } = useSelector(gameContextSelector);

  const requestId = useSelector(requestIdSelector);

  const updateAuthToken = useCallback(
    (event) => {
      if (sessionContext && requestId && userId) {
        const { authToken } = getAuthCookies();
        const payloadToken = event?.data?.payload?.jwt ?? authToken;

        if (!payloadToken) {
          return;
        }

        const product: UpdateAuthProduct = PokerProviderNamesToFgp.includes(
          ProviderNameToFgp[provider ?? ''],
        )
          ? (Product.Poker.toUpperCase() as UpdateAuthProduct)
          : (Product.Casino.toUpperCase() as UpdateAuthProduct);

        dispatch(
          updateAuthenticationToken({
            requestId,
            userId,
            authToken: payloadToken,
            product,
            fdState: sessionContext?.fdState,
          }),
        );
      }
    },
    [sessionContext, dispatch, requestId, userId, provider],
  );

  return { updateAuthToken };
};
